module.exports = __webpack_public_path__ + "img/cow-pixel.75709d41.png";